export default {
    title: 'Approvals',
    description: 'Approve or reject what your team uploads and records before it reaches your channel.',
    quickStart: {
        howItWorks: 'How it works',
        eyebrow: 'A QUICK START',
        titleFirst: 'All media created, checked.',
        titleSecond: 'You make the call.',
        description: 'Your team records and uploads. You decide what goes out.',
        dismiss: 'Dismiss Approvals introduction',
        stepsLabel: 'How Approvals works',
        steps: {
            arrives: {
                title: 'It lands here',
                description: 'New uploads, recordings and edits wait in Pending until someone approves them.',
            },
            checked: {
                title: 'Brand Brain checks',
                description: 'Each one is checked against your brand book, knowledge files and memories, with a reason when something looks off.',
            },
            decide: {
                title: 'Approve or reject',
                description: 'Approve to publish it to your channel, or reject it with a note so your team knows what to change.',
            },
            record: {
                title: 'Keep a record',
                description: 'Approved and Rejected show who decided and when. Filter by person or role.',
            },
        },
        footnote: 'Nothing here reaches your channel until someone approves it.',
    },
    filter: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        label: 'Filter approvals',
    },
    sort: {
        label: 'Sort by',
        newest: 'Newest',
        oldest: 'Oldest',
        decider: 'Decided by (A to Z)',
        requested: 'Date requested',
    },
    toolbar: {
        decidedBy: 'Decided by',
        anyone: 'Anyone',
        role: 'Role',
        anyRole: 'Any role',
        clear: 'Clear filters',
    },
    role: {
        marketscale: 'MarketScale',
        admin: 'Admin',
        standard: 'Standard',
        contributor: 'Contributor',
    },
    type: {
        video: 'Video',
        bulk: 'Bundle',
        podcast: 'Podcast',
        course: 'Course',
    },
    approvedBy: 'Approved by {name}',
    rejectedBy: 'Rejected by {name}',
    approvedUnknown: 'Approved',
    rejectedUnknown: 'Rejected',
    untitled: 'Untitled',
    bypassed: 'Brand Brain checks bypassed',
    reason: 'Reason: {notes}',
    showMore: 'Show more',
    empty: {
        approved: {
            title: 'Nothing approved yet',
            description: 'When someone approves an item, it shows here with who approved it and when.',
        },
        rejected: {
            title: 'Nothing rejected yet',
            description: 'When someone rejects an item, it shows here with the reason they gave.',
        },
        filtered: {
            title: 'No matches',
            description: 'Nothing matches these filters. Try another person or role.',
        },
        failed: {
            title: "We couldn't load this list",
            description: 'Something went wrong on our side. Try again in a moment.',
        },
        showPending: "See what's pending",
        retry: 'Try again',
    },
}
